import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const UploadDocument = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [uploading, setUploading] = useState(false); // Fix: Added uploading state
    const [formData, setFormData] = useState({
        documentName: "Photo",
        document: null, // Store file object
    });

    // Handle text input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle file input change
    const handleFileChange = (e) => {
        setFormData({ ...formData, document: e.target.files[0] }); // Store file object
    };

    // Simulated Upload Function
    const handleUpload = async () => {
        if (!formData.document) {
            alert("Please select a document before uploading.");
            return;
        }

        setUploading(true);

        setTimeout(() => {
            alert(`File "${formData.document.name}" uploaded successfully!`);
            setUploading(false);
            setIsEditing(false);
        }, 2000); // Simulated upload delay
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Upload Document</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleUpload} className="btn btn-success btn-sm me-2" disabled={uploading}>
                            {uploading ? "Uploading..." : <><Save size={18} className="me-1" /> Save</>}
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    {/* Document Name */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">Document Name</label>
                        {isEditing ? (
                            <input
                                type="text"
                                name="documentName"
                                className="form-control input-me f-14"
                                value={formData.documentName}
                                onChange={handleChange}
                            />
                        ) : (
                            <p className="mb-0 f-13">{formData.documentName}</p>
                        )}
                    </div>

                    {/* File Upload */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">Document</label>
                        <input type="file" className="form-control input-me" onChange={handleFileChange} />
                        {formData.document && <p className="mt-2">Selected file: {formData.document.name}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadDocument;
